import { render, staticRenderFns } from "./pagination-component.vue?vue&type=template&id=438972d7&scoped=true"
import script from "./pagination-component.vue?vue&type=script&lang=js"
export * from "./pagination-component.vue?vue&type=script&lang=js"
import style0 from "./pagination-component.vue?vue&type=style&index=0&id=438972d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438972d7",
  null
  
)

export default component.exports